import { CustomAction } from '@nimmsta/ng-commons-lib/data-table';
import { DataConnectionType, Job } from '@nimmsta/ng-commons-lib/models';
import { Observable, of } from 'rxjs';

export class CsvJobPriorityAction extends CustomAction<Job> {
  constructor(
    _text: string,
    isDelete = false,
  ) {
    super(_text, false, isDelete);
  }

  override getText(item: Job): string {
    if (item.priorityDate) {
      return 'job.remove-priority';
    } else {
      return 'job.add-priority';
    }
  }

  override isEnabled(item: Job): Observable<boolean> {
    return of(item?.dataConnection?.dataConnectionHandler === DataConnectionType.CSVDataConnection);
  }
}
